import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'scorecard-details',
  templateUrl: 'scorecard-details.component.html',
  styleUrls: ['scorecard-details.component.scss'],
})
export class ScorecardDetailsComponent {
  @Input() hint: string;
  @Input() example: string;
  @Input() entryDetail: string;
  @Input() valid: number|boolean;
  @Input() controlLabel: string;
  @Input() fieldMap: string;
}
